import { useCallback, useMemo } from 'react';
import { useQuery } from './query';

const useCurrency = ({
  isAvailableFilter,
  dispatch,
  getCurrencies,
  integrationSettings,
  meta,
  pageContext,
  value,
  initValue
}) => {
  const getData = () => {
    return getCurrencies(integrationSettings, meta, pageContext)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  const currencies = useQuery({ getData, active: isAvailableFilter }, [
    integrationSettings,
    meta,
    getCurrencies
  ]);

  const outputCurrencies = useMemo(() => {
    if (!currencies.data) {
      return [];
    }

    return currencies.data.map((currency) => currency.currencyCode);
  }, [currencies.data]);

  const onChange = useCallback(
    (selectedUnit) => {
      dispatch({ type: 'CURRENCY_CHANGE', payload: selectedUnit.value });
    },
    [dispatch]
  );

  return useMemo(
    () => ({
      value,
      onChange,
      isChanged: initValue !== value,
      currencies,
      outputCurrencies,
      isAvailableFilter
    }),
    [value, initValue, onChange, currencies, outputCurrencies, isAvailableFilter]
  );
};

export default useCurrency;
